
import { Card } from "@/components/ui/card";
import { Loader2, Package, Filter, RotateCcw } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/use-theme";

interface NoBookingsProps {
  activeFilter: string;
  onResetFilter?: () => void;
}

export const BookingsLoading = () => {
  const { primaryColor } = useTheme();
  
  return (
    <div className="flex justify-center items-center py-12">
      <Loader2 className="h-8 w-8 animate-spin" style={{ color: primaryColor }} />
    </div>
  );
};

export const BookingsError = () => (
  <Card className="bg-white rounded-lg shadow p-4 md:p-6">
    <p className="text-center text-red-600">Failed to load bookings. Please try again later.</p>
  </Card>
);

export const NoBookings = ({ activeFilter, onResetFilter }: NoBookingsProps) => {
  const { primaryColor } = useTheme();
  
  return (
    <Card className="bg-card border border-border p-6 md:p-8">
      {activeFilter === "all" ? (
        <div className="text-center">
          <Package className="mx-auto h-16 w-16 text-muted-foreground/50" />
          <h3 className="mt-4 text-xl font-semibold text-foreground">No bookings found</h3>
          <p className="mt-2 text-muted-foreground">You haven't made any parcel bookings yet.</p>
          <div className="mt-6">
            <Link to="/app">
              <Button>
                Book a Parcel
              </Button>
            </Link>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <Filter className="mx-auto h-16 w-16 text-muted-foreground/50" />
          <h3 className="mt-4 text-xl font-semibold text-foreground">No {activeFilter} bookings found</h3>
          <p className="mt-2 text-muted-foreground">Try adjusting your filter or view all bookings.</p>
          {onResetFilter && (
            <div className="mt-6">
              <Button variant="outline" onClick={onResetFilter} className="gap-2">
                <RotateCcw className="h-4 w-4" />
                Show All Bookings
              </Button>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export const LoadingMore = () => {
  const { primaryColor } = useTheme();
  
  return (
    <div className="py-4 flex flex-col items-center">
      <Loader2 className="h-6 w-6 animate-spin mb-2" style={{ color: primaryColor }} />
      <p className="text-sm text-gray-500">Loading more bookings...</p>
    </div>
  );
};

export const EndOfResults = () => (
  <div className="py-4 text-center text-sm text-gray-500">
    No more bookings to load
  </div>
);
